import { useState } from 'react';

import { cn } from '@/lib/utils';

import { Button } from './button';

export type CodeBlockProps = {
  code: string;
  className?: string;
  showCopy?: boolean;
};

function CodeBlock({
  code,
  className,
  showCopy = true,
}: Readonly<CodeBlockProps>) {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(code);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy code:', err);
    }
  };

  return (
    <div data-slot="code-block" className={cn('group relative', className)}>
      {showCopy && (
        <div className="absolute top-2 right-2 opacity-0 transition-opacity group-hover:opacity-100">
          <Button
            variant="ghost"
            size="sm"
            onClick={handleCopy}
            className="bg-background/80 hover:bg-background text-xs"
          >
            {copied ? '✓ Copied' : 'Copy'}
          </Button>
        </div>
      )}
      <pre
        className={cn(
          'bg-muted-active/50 overflow-x-auto rounded-lg border p-4 text-sm',
          showCopy && 'pr-24'
        )}
      >
        <code className="text-foreground font-mono">{code}</code>
      </pre>
    </div>
  );
}

export { CodeBlock };
export default CodeBlock;
